const opvalStickerFormatter = (opvalStickerText?: string): string =>
  opvalStickerText ? opvalStickerText.charAt(0).toUpperCase() + opvalStickerText.toLowerCase().slice(1) : '';

export default opvalStickerFormatter;
